import React from "react";
import Section from '../../pages/CmsPage/Section';
import CmsPageContent from '../../pages/CmsPage/CmsPageContent';
import { useParams } from "react-router-dom";
import MetaTags from '../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../helpers/Common/metaConfig';

const CmsPage = () => {
  const { page } = useParams();
  const pageTitle = page?.replace(/-/gi, ' ').toUpperCase();
  
  const cmsPageMeta = getMetaConfig('cmsPage', {
    title: pageTitle || 'Page',
    description: `Informative content about ${pageTitle || 'our platform'} from JobSeekers Page. Stay updated with the latest information about our services and features.`,
    keywords: `${pageTitle || 'jobseekers page'}, platform information, helpful content, career resources`,
    ogTitle: `${pageTitle || 'Page'} - JobSeekers Page`,
    ogDescription: `Access helpful content and resources about ${pageTitle || 'our job search and hiring platform'}.`,
  });

  return (
    <>
      <React.Fragment>
        <MetaTags {...cmsPageMeta} />
        <Section />
        <CmsPageContent />
      </React.Fragment>
    </>
  );
};

export default CmsPage;
